<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h1>Registrar</h1>
                <p class="text-muted">Criar sua conta</p>


                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      :description="usernameError"
                      label=""
                      label-for="username"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input  v-model="username" ref="username" type="text" class="form-control" :class="usernameField" required placeholder="Usuário / E-mail" autocomplete="username" 
                          @blur="checkUsername()" />
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>

                
                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      label=""
                      label-for="name"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text><i class="icon-wallet"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input  v-model="name" ref="name" type="text" class="form-control" :class="nameField" required placeholder="Nome completo" autocomplete="name"  />
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      :description="emailError"
                      label=""
                      label-for="email"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text>@</b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input v-model="email" ref="email" type="text" class="form-control" :class="emailField" required placeholder="E-mail" autocomplete="email" 
                        @blur="checkEmail()"/>
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      :description="passwordError"
                      label=""
                      label-for="passord"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input v-model="password" ref="password" type="password" :class="passwordField" class="form-control" required placeholder="Senha" 
                        @blur="checkPassword()"  />
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      :description="password2Error"
                      label=""
                      label-for="password2"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-4">
                        <b-input-group-prepend>
                          <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input v-model="password2" ref="password2" type="password" class="form-control" :class="password2Field" required placeholder="Confirmar senha" 
                        @blur="checkPassword()"  />
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>
                
                <b-input-group class="mb-4">
                    <div class="text-danger" v-if="this.errormessage && this.errormessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errormessage }}</div>
                </b-input-group>

                <!--
                <b-button variant="success" block>Criar Conta</b-button>
                -->
              </b-form>
            </b-card-body>
            <b-card-footer class="p-4">
              <b-row>
                <b-col cols="6">                  
                  <b-button block class="btn btn-facebook" @click="backLogin"><span>Voltar</span></b-button>
                </b-col>
                <b-col cols="6">
                  <b-button block class="btn btn-twitter" type="button" @click="createAccount"><span>Criar Conta</span></b-button>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: 'Register',

  data: function() {
    return {
      passwordPolicy: /^.{8,}$/,
      passwordPolicyMessage: 'No mínimo 8 caracteres',

      errormessage: '',
      
      name: '',
      nameField: '',
      
      username: '',
      usernameError: '',
      usernameField: '',

      email: '',
      emailError: '',
      emailField: '',

      password: '',
      passwordError: '',
      passwordField: '',

      password2: '',
      password2Error: '',
      password2Field: ''

    }
  },

  methods: {
  

    async saveNewAccount() {
      var s = this;
      this.errormessage = '';

      await axios.post(
          this.$store.state.ws_url + "/user/register",
          {
            "companyId": s.$store.state.config.companyId,
            "username": this.username,
            "name": this.name,
            "email": this.email,
            "password": this.password
          }          
      ).then(function(resp) {
        s.errormessage = resp.data.message
        s.password = "";
        s.password2 = "";
      }).catch(function (error) {
        console.log(error)
        s.errormessage = error.response.data.message;
      });


    },

    async checkUsername() {
      var s = this
      //console.log(this.$store.state.ws_url + "/user/check/username/" + this.username)
      await axios.get(
        this.$store.state.ws_url + "/user/check/username/" + this.username
      ).then(function(resp) {
        console.log(resp)
        s.usernameField = resp.data.obj > 0 ? 'is-invalid' : ''
        s.usernameError = resp.data.obj > 0 ? resp.data.message : ''

      }).catch(function(error) {
        s.usernameError = ''
        s.usernameField = ''
      })
    },

    async checkEmail() {
      var s = this
      
      if(this.email && this.email.length > 0) {
        if(this.$utils.checkEmail(this.email)) {
          //console.log(this.$store.state.ws_url + "/user/check/email/" + this.email)

          await axios.get(
            this.$store.state.ws_url + "/user/check/email/" + this.email
          ).then(function(resp) {
            console.log(resp)
            s.emailField = resp.data.obj > 0 ? 'is-invalid' : ''
            s.emailError = resp.data.obj > 0 ? resp.data.message : ''
            
          }).catch(function(error) {
            s.emailError = ''
            s.emailField = ''
          })
        }
        else {
          s.emailError = 'E-mail inválido. Verifique e tente novamente'
          s.emailField = 'is-invalid'
        }
      }
      else {
        s.emailError = ''
        s.emailField = ''
      }
      

    },

    checkPassword() {
      var s = this
      if(this.password && this.password.length > 0) {
        if(this.passwordPolicy.test(this.password)) {
          s.passwordField = ''
          s.passwordError = ''

          if(this.password2 && this.password2.length > 0) {
            s.password2Field = this.password === this.password2 ? '' : 'is-invalid'
            s.password2Error = this.password === this.password2 ? '' : 'Senhas diferentes. Verifique e tente novamente.'
          }
        }
        else {
          s.passwordField = 'is-invalid'
          s.passwordError = this.passwordPolicyMessage
        }
      }
      else {
        s.passwordField = ''
        s.passwordError = ''
      }
      
    },

    createAccount() {
      
    },
    backToPortal() {
      this.$router.push({ path: '/dashboard' })
    },
    backLogin() {
      this.$router.push({ path: '/pages/login' })
    },

    async getPreferences() {
      
      var s = this
      await axios.get(
        this.$store.state.ws_url + "/sys/preference/password/policy?companyId=" + this.$store.state.config.companyId
      ).then(function(resp) {
        s.passwordPolicy = new RegExp(resp.data.obj.stringPreference)
        s.passwordPolicyMessage = resp.data.obj.description
      }).catch(function(error) {
        s.passwordPolicy = /^.{8,}$/
      })
    }

  },


  mounted: function() {
      this.getPreferences()
  }

}
</script>
